export function getEvaluationStatusColor(
  statusName: string,
): 'success' | 'error' | 'warning' | 'default' {
  switch (statusName) {
    case 'Aprobado':
      return 'success';
    case 'Rechazado':
      return 'error';
    default:
      return 'warning';
  }
}
